import React from 'react';
import ReactLoading from 'react-loading';
import './PdfLoader.scss';

const PdfLoader = () => (
  <div className="pdf-loader">
    <ReactLoading height="44px" width="44px" color="#00599b" type="spin" />
  </div>
);

export default PdfLoader;
